module.exports = __webpack_public_path__ + "img/announce.7f053cb8.png";